<template>
  <span
    class="inline-flex shrink-0 items-center gap-0.5"
    aria-hidden="true"
    data-testid="typing-dots"
  >
    <span class="size-1 rounded-full bg-current motion-safe:animate-bounce" />
    <span
      class="size-1 rounded-full bg-current motion-safe:animate-bounce [animation-delay:120ms]"
    />
    <span
      class="size-1 rounded-full bg-current motion-safe:animate-bounce [animation-delay:240ms]"
    />
  </span>
</template>
